
export const pricing = {
  'request.pricing': '请求报价',
  'view.pricing': '查看价格',
  'product.pricing': '产品定价',
  'pricing.title': '价格表',
  'pricing.description': '请联系我们获取详细价格信息',
  'pricing.request': '申请价格信息',
  'pricing.submit': '提交请求',
  'pricing.contact': '联系销售团队',
};
